/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { Typography } from 'ui-v2/components/Typography';
import { Button } from 'ui-v2/components/Button';
import Modal from 'ui-v2/components/Modal';
import s from './Unserviceable.module.scss';
import NonServiceableSVG from "../../icons/nonServiceable.svg"

type UnservicableProps = {
  isShow: boolean;
  onClose: () => void;
  onDone: () => void;
  zIndex?: number
};

export const Unserviceable = ({
  isShow,
  onClose,
  onDone,
  zIndex = 105
}: UnservicableProps) => (
  <Modal
    show={isShow}
    head={{ show: true, title: '', onClose: onClose }}
    closeOnClickOutside={false}
    noPadding
    animation={{ type: 'btt', timeout: 's' }}
    rootStyle={{
      zIndex,
    }}
  >
    <div className={s.root}>
      <div className={s.upper}>
        <div className={s.image_container}>
          <NonServiceableSVG />
        </div>
        <div className={s.text_container}>
          <div className={s.title}>
            <Typography
              variant="h_3_bold"
              label="We’re not there yet!"
            />
          </div>
          <div className={s.sub_title}>
            <Typography
              variant="body_2_medium"
              color="secondary"
              label={
                 " Your location is currently non-serviceable"
              }
            />
          </div>
        </div>
      </div>

      <div className={s.button_container}>
        <Button label="Change location" onClick={onDone} size='medium' variant='primary' fullWidth />
      </div>
    </div>
  </Modal>
);
